import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useGetTeamsQuery } from "../../features/team/teamApi";
import ModalForAddingTeam from "../PageComponents/ModalForAddingTeam";
import ModalForAddingMember from "../PageComponents/ModalForAddingMember";

import Navbar from "../PageComponents/Navbar";
import Team from "./Team";

export default function Teams() {
  const [modal, setModal] = useState(false);
  const auth = useSelector((state) => state.auth);
  const { isOpen, team } = useSelector((state) => state.team);
  const user = auth?.user?.email;
  const { data: teams, isLoading } = useGetTeamsQuery(user);
  if (isLoading) {
    return <div>Loading...</div>;
  }
  return (
    <div className="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200">
      <Navbar />
      <div className="px-10 mt-6 flex justify-between">
        <h1 className="text-2xl font-bold">Teams</h1>
        <button
          onClick={() => setModal(true)}
          className="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            ></path>
          </svg>
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-10 mt-4 gap-6 overflow-auto">
        {teams?.map((team) => (
          <Team key={team.id} team={team} />
        ))}
      </div>
      {modal && <ModalForAddingTeam setModal={setModal} />}
      {isOpen && <ModalForAddingMember />}
    </div>
  );
}
